// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1aaa1f16","239":"4abf697b","455":"7c678c2b"}[chunkId] + ".chunk.js";
};